//#region src/api/route.ts
/**
* Helper to resolve route factories into routes
* @internal
*/
function resolveRouteFactories(context, routesOrFactories) {
	const routes = [];
	for (const item of routesOrFactories) if (typeof item === "function") {
		const factoryRoutes = item(context);
		routes.push(...factoryRoutes);
	} else routes.push(item);
	return routes;
}
function defineRoute(config) {
	return config;
}
function defineRoutes(_definition) {
	return { create: (fn) => {
		return (ctx) => {
			return fn({
				...ctx,
				defineRoute
			});
		};
	} };
}

//#endregion
export { defineRoute, defineRoutes, resolveRouteFactories };
//# sourceMappingURL=route.js.map